import axios from 'axios';

const request = (method, url, data) => axios({
  method,
  url,
  data,
}).then(result => result.data);


export const brand = {
  fetch() {
    return request('get', '/api/brand');
  },
};

export const car = {
  fetch() {
    return request('get', '/api/car');
  },
};

export const carEstimate = {
  fetch(bId) {
    return request('get', `/api/car/${bId}`);
  },
};

export const sms = {
  sendSms(message) {
    return request('post', '/api/sms', message);
  },
};

export const requestboard = {
  fetch() {
    return request('get', '/api/requestboard');
  },
};

export const carGroup = {
  fetch() {
    return request('get', '/api/carGroup');
  },
};
